<template>
    <div id="reach" class="flex m-row" :style="`height: ${Height()}`">

        <!-- Impact: Highlights audience and total impacted -->
        <Detail
            v-if="ShowImpact()"
            area="Impact"
            :properties="ReachProperties()"
            :showDivider="ShowImpact() && mobile"
            :reachProperties="ReachProperties()"
        >
            <div id="impact-value-details" class="flex-center">
                <span id="description-detail" :class="Classes().descriptionDetailNoValue">{{ impact.Description }}</span>
                <div id="impact-divider" v-if="ShowImpactValue()"></div>
                <div id="impact-value" v-if="ShowImpactValue()">
                    <span id="audience-detail" class="value-number">{{ ImpactValue() }}</span> <span id="value-description">{{ impact.ValueDescription }}</span>
                </div>
                <div v-else>
                    <span id="audience-detail">{{ impact.ValueDescription }}</span>
                </div>
            </div>
        </Detail>

        <!-- Cause: Highlights cause area -->
        <Detail
            v-if="cause"
            area="Cause"
            :cause="cause"
            :properties="ReachProperties()"
            :showDivider="ShowImpact() && mobile"
            :reachProperties="ReachProperties()"
        >
            <div id="impact-value-details" class="flex-center">
                <p class="value-description">{{ cause }}</p>
            </div>
        </Detail>

    </div>
</template>

<script>
import Detail from "@/components/Projects/Project/Reach/Detail.vue";
import { MASTER } from "@/assets/JS/Master.js";

export default {
    name: "ProjectImpact",
    props: {
        impact: Object,
        cause: String,
        mobile: Boolean
    },
    components: { Detail },
    methods: {

        // Impact
        ImpactValue: function() {
            const { Value } = this.impact;
            return MASTER.Numbers.PlaceValue(Value);
        },
        ImpactType: function() {
            return this.impact.Value > 0 ? "number" : "description";
        },
        ShowImpact: function() { return Object.keys(this.impact).length > 0; },

        ReachProperties: function() {
            let totalReach, width;
            totalReach = width = 0;
            if (this.ShowImpact()) {
                totalReach++;
            }
            if (this.cause) {
                totalReach++;
            }
            if (totalReach > 0) {
                if (!this.mobile) {
                    width = totalReach === 1 ? 100 : 50;
                } else {
                    width = 100;
                }
            }
            return {
                width,
                totalReach
            };
        },
        Height: function() {
            let height = "auto";
            if (this.ReachProperties().totalReach > 0 && !this.mobile) {
                height = "110px";
            }
            return height;
        },
        Classes: function() {
            return {
                descriptionDetailNoValue: this.impact.Value === 0 ? "no-margin-t" : ""
            };
        },
        ShowImpactValue: function() { return this.impact.Value > 0; }
    }
};
</script>